// extracted by mini-css-extract-plugin
export var change = "_3l-1";
export var changeList = "_3l-0";
export var changePath = "_3l-2";
export var diffArrow = "_3l-5";
export var diffRow = "_3l-3";
export var diffValue = "_3l-4";
export var error = "_3l-8";
export var notice = "_3l-9";
export var result = "_3l-6";
export var success = "_3l-7";